import InputSelectComponent from 'components/inputSelectComponent'
import React, { useContext, useEffect, useState } from 'react'

import RechargeContext from 'contexts/rechargeContext'
import {countries} from '../rechargeContainer/countryRecharge'


import classNames from 'classnames'
import { getCurrenciesWithServices } from 'helpers/api'

interface TypeOption{
  image:string,
  value:string,
  code:string,
  styleLogo?:string
  
}
interface Country {
  image: string
  value: string
  digits: number | number[]
  codeIso: string
  code: string
  countryCode:string
  operator: {
    code: string
    value: string
    image: string
    styleLogo: string
  }[]
}

interface Props {
    onChangeStep:()=>void
    functionTracks: (val:string)=>void
    prefixeSelected:string,
    setPrefixeSelected: (val:string)=>void
    setChoixPaiement:(val:string)=>void,
    setCodeIso?:(val:string)=>void
    
}

const Beneficiare: React.FC<Props> =({
     setPrefixeSelected, prefixeSelected,
     setChoixPaiement, onChangeStep, functionTracks, setCodeIso
}) => {

  

  const optionsLien = [
    { index: 0, code: 'cb', value: 'Carte Bancaire' },
    { index: 1, code: 'volume', value: 'Virement instantané' },
  ]

  const { recharges, setRecharges } = useContext(RechargeContext)
  const [isOpenLien, setIsOpenLien] = useState(false)
  const [paysSelected, setPaysSelected] = useState<string>('')
  const [phoneNumber, setPhoneNumber] = useState<string>(recharges?.phoneNumber || '')
  const [operateur, setOperateur] = useState<string>(recharges?.isOperateur || '')
  const [messageErreur, setMessageErreur] = useState<string>('')
  const [icon, setIcon]=useState(countries.find((item:TypeOption)=>item.code === prefixeSelected)?.image)
  const [isOpenListePays, setIsOpenListePays]=useState(false)
  const [selectedOptionLien, setSelectedOptionLien]= useState('Carte Bancaire')
  const [listeCarte, setListCarte] = useState<TypeOption[]>()
  const [listeCountry, setListeCounty] = useState<Country[]>(countries)


  const phoneRules = listeCountry.reduce((acc, item) => {
  acc[item.code] = item.digits
  return acc
}, {} as Record<string, number | number[]>)

useEffect(()=>{
  async function fetchData()
{
  const response= await getCurrenciesWithServices()

  const filtresPays = response.filter((item:any)=>item.isRecharge).map((item:any)=>item.countryCode)
  const filtreListe= countries.filter((item: Country)=>filtresPays.includes(item.countryCode))
  .sort((a, b) => a.value.localeCompare(b.value, 'fr', { sensitivity: 'base' }))
  setListeCounty(filtreListe)

} 
fetchData() 
},[])

 useEffect(()=>{
  const selectedOption= listeCountry.find((item:TypeOption)=>item.code === prefixeSelected)
  if(selectedOption){
  setIcon(selectedOption?.image)
  setPaysSelected(selectedOption?.value || '')
  if(setCodeIso){ setCodeIso(selectedOption.codeIso)}
    setRecharges({...recharges, MontantDinar:'', MontantEur:'', ReceiveValueExcludingTax:0, ReceiveCurrencyIso:''})
    
    setListCarte(selectedOption.operator)
 
}

    const error=validatePhone(phoneNumber, prefixeSelected)
    if (error) {setMessageErreur(error)}
    else{setMessageErreur('')}
 },[prefixeSelected]) 

 const validatePhone = (value: string, prefix: string) => {
  if (!value) {
    return ''
  }
   const rule = phoneRules[prefix]
  

  if (!rule) return "Préfixe non supporté"

  const digits = value.replace(/\D/g, "")

  if (Array.isArray(rule)) {
    if (!rule.includes(digits.length)) {
      return `Le numéro doit contenir ${rule.join(" ou ")} chiffres`
    }
  } else {
    if (digits.length !== rule) {
      return `Le numéro doit contenir ${rule} chiffres`
    }
  }

  return ""
}



  const handleSelectChange =(objectSelected:TypeOption)=>{
    setPaysSelected(objectSelected.value)
    setPrefixeSelected(objectSelected.code)
    setIcon(objectSelected?.image)
    setOperateur('')
    // setRecharges({...recharges, prefix: objectSelected.code, indexRechargeTN: -1, isOperateur:'', labelOperateur:'',MontantDinar:'', MontantEur:''})
    setRecharges({ prefix: objectSelected.code, indexRechargeTN: -1, phoneNumber:phoneNumber})
}
const handleSelectedPaymentMode=(val:TypeOption)=>{
  setChoixPaiement(val.code)
  setSelectedOptionLien(val.value)
}

const handleInputChange =(event:any)=>{

  const inputValueWithoutSpaces = event.target.value.replace(/\D/g, '')
    const error= validatePhone(inputValueWithoutSpaces, prefixeSelected)
    setMessageErreur(error)
    
    setPhoneNumber(inputValueWithoutSpaces)
      if(!error)
      {setRecharges({...recharges, phoneNumber:inputValueWithoutSpaces})
      setMessageErreur('')
    }
}

const hadleselectetdOperateur =(item:TypeOption)=>{
  setOperateur(item.code)
  setRecharges({...recharges, isOperateur:item.code, labelOperateur:item.value,indexRechargeTN: -1, })

}

  return (
    <div className='w-full flex flex-col gap-6'>
        <InputSelectComponent
          liste={listeCountry}
          isOpen={isOpenListePays}
          setIsOpen={setIsOpenListePays}
          value={paysSelected}
          setValue={setPaysSelected}
          placeholder='Choisir'
          label='Sélectionnez le pays de destination'
          icon={icon}
          handleClick={handleSelectChange}
          messageIsEmpty=''
        /> 


        <InputSelectComponent
          liste={optionsLien}
          isOpen={isOpenLien}
          setIsOpen={setIsOpenLien}
          value={selectedOptionLien}
          setValue={setSelectedOptionLien}
          label='Mode de paiement'
          handleClick={handleSelectedPaymentMode}
        />
        <div className='flex flex-col '>
          <h3 className='h3'>Entrez le numéro du bénéficiaire <span className="text-[#EE443F]">*</span></h3>
          <div className='flex items-center font-roboto mt-3 font-medium text-[16px] w-full px-4 h-[56px] border border-[#AEB6FB] focus-within:border-[#5754E5] rounded-[16px]'>
             <div className={`bg-[#F1F1FF] rounded-[8px]  h-[32px] px-3 justify-center  flex items-center `}>
                <img src={icon} width={25} height={25}/>
                <span className="text-[#8F8FCD]  pl-1">{prefixeSelected}</span>
             </div>
             <input
              className='outline-none pl-3 w-full text-[#35258B] focus:text-[#5754E5] placeholder:text-[#D1D1FF] rounded-[14px]  focus:border-[#5754E5]  `'
              type="text"
              value={phoneNumber}
              placeholder={'Numéro de téléphone'}
              name="phone"
              autoComplete="off"
              onChange={handleInputChange}
            />
        </div>
             <div className='text-[#EE443F] text-[14px] h-[10px]'> {messageErreur}</div>

        </div>

      <div className='flex gap-[3%] items-center'>
        {listeCarte?.map((item:TypeOption, index:number)=>(
          <div key={index}
          onClick={()=>hadleselectetdOperateur(item)}
           className={` ${operateur ? (operateur=== item.code ? ' ring-2 ring-[#5754E5] ring-offset-4 rounded-[9px] bg-[#E2E2FB]': ' opacity-65 bg-[#EEEEEE]') : 'bg-[#EEEEEE]'} cursor-pointer rounded-[4px] flex items-center justify-center sm:h-[63px] w-full h-[100px]`}>

          <img className={`${item.styleLogo}`} src={item.image} alt={item.value}/>
          </div>
        ))}

      </div>


     <div className={`flex gap-[16px] justify-center my-5 place-self-center sm:px-14 w-full`}>
            <button
              className={classNames(
                `text-[16px] text-[#FFF]  p-2 h-[56px]  items-center rounded-[16px] sm:w-[100%]  lg:w-[50%] w-[300px]`,
                !recharges?.isOperateur || messageErreur!=='' ?'bg-[#D1D1FF]' : 'bg-[#5754E5]',
              )}
              onClick={() => {
                if(phoneNumber)
                {onChangeStep()
                functionTracks('1')}
                else {setMessageErreur('Ce champ est requis')}
              }}
              disabled={ !recharges?.isOperateur  || messageErreur!==''  }
            >
              Suivant
            </button>
            </div>
    </div>
  )
}

export default Beneficiare